import * as React from "react";
import t from "./locales";
import Loading from "../Shared/Loading";
import LessonItem from "./LessonSchoolItem";
import { ILesson } from "./types";

interface ILessonListProps {
	currentLessons: ILesson[];
	localCurrency: any;
	isLoading: boolean;
}

const LessonList: React.FC<ILessonListProps> = ({
	currentLessons,
	localCurrency,
	isLoading,
}) => {
	return (
		<>
			{currentLessons.length === 0 && (
				<p style={{ padding: "8px 0" }}>{t.notFound()}</p>
			)}
			{isLoading ? (
				<Loading isLoading={true} />
			) : (
				currentLessons.map((lesson) => (
					<LessonItem
						lesson={lesson}
						localCurrency={localCurrency}
						key={lesson.snowItemId}
					/>
				))
			)}
		</>
	);
};

export default LessonList;
